import { useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { clearBriefingToken } from '../../utils/briefingIntent';
import { clearMonitoringToken } from '../../utils/monitoringIntent';
import { clearPricingSelection, parsePricingSelection, pricingUpgradePath, rememberPricingSelection } from '../../utils/pricingIntent';

export default function StartPricing() {
  const { isAuthenticated, isLoading } = useAuth();
  const { search } = useLocation();
  const navigate = useNavigate();
  const selection = parsePricingSelection(search);
  const isFree = new URLSearchParams(search).getAll('plan').join(',') === 'free';

  useEffect(() => {
    if (isLoading) return;
    if (isFree) {
      clearPricingSelection();
      navigate(isAuthenticated ? '/dashboard' : '/register', { replace: true });
      return;
    }
    const selected = parsePricingSelection(search);
    if (!selected) { clearPricingSelection(); return; }
    if (isAuthenticated) clearPricingSelection();
    else rememberPricingSelection(selected);
    try { clearBriefingToken(); clearMonitoringToken(); } catch { /* Storage may be blocked. */ }
    const target = pricingUpgradePath(selected);
    navigate(isAuthenticated ? target : '/register', {
      replace: true,
      state: { from: { pathname: '/admin/billing/upgrade', search: target.slice(target.indexOf('?')) } },
    });
  }, [isAuthenticated, isLoading, isFree, search, navigate]);

  if (isLoading || selection || isFree) return <main aria-busy="true">Preparing your selected plan…</main>;
  return <main style={{ margin: '10vh auto', maxWidth: 480, padding: 24 }}>
    <h1>Choose a plan to continue</h1>
    <p>This pricing link is incomplete or invalid.</p>
    <p><a href="https://lazysem.com/pricing">Return to pricing</a></p>
    <p><Link to="/admin/billing/upgrade">View available plans</Link></p>
  </main>;
}
